import React from 'react';

export type NavigationItem = 'overview' | 'clients' | 'meals' | 'insights' | 'leaderboard' | 'diet' | 'trends' | 'subscription';

interface BottomNavigationProps {
  currentView: NavigationItem;
  onNavigate: (view: NavigationItem) => void;
  selectedUserId?: string;
}

const navigationItems = [
  {
    id: 'overview' as NavigationItem,
    label: 'Overview',
    icon: '📊',
    color: 'text-neon-blue',
    bgColor: 'bg-neon-blue',
    bgOpacity: 'bg-opacity-10'
  },
  {
    id: 'clients' as NavigationItem,
    label: 'Clients',
    icon: '👥',
    color: 'text-neon-green',
    bgColor: 'bg-neon-green',
    bgOpacity: 'bg-opacity-10'
  },
  {
    id: 'meals' as NavigationItem,
    label: 'Meals',
    icon: '🍽️',
    color: 'text-yellow-500',
    bgColor: 'bg-yellow-500',
    bgOpacity: 'bg-opacity-10',
    requiresClient: true
  },
  {
    id: 'insights' as NavigationItem,
    label: 'Insights',
    icon: '🧠',
    color: 'text-purple-500',
    bgColor: 'bg-purple-500',
    bgOpacity: 'bg-opacity-10',
    requiresClient: true
  },
  {
    id: 'diet' as NavigationItem,
    label: 'Diet',
    icon: '🎯',
    color: 'text-red-500',
    bgColor: 'bg-red-500',
    bgOpacity: 'bg-opacity-10',
    requiresClient: true
  },
  {
    id: 'trends' as NavigationItem,
    label: 'Trends',
    icon: '📈',
    color: 'text-indigo-500',
    bgColor: 'bg-indigo-500',
    bgOpacity: 'bg-opacity-10',
    requiresClient: true
  },
  {
    id: 'leaderboard' as NavigationItem,
    label: 'Leaderboard',
    icon: '🏆',
    color: 'text-orange-500',
    bgColor: 'bg-orange-500',
    bgOpacity: 'bg-opacity-10'
  },
  {
    id: 'subscription' as NavigationItem,
    label: 'Pricing',
    icon: '💰',
    color: 'text-green-600',
    bgColor: 'bg-green-600',
    bgOpacity: 'bg-opacity-10'
  }
];

export function BottomNavigation({ currentView, onNavigate, selectedUserId }: BottomNavigationProps) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
      <div className="flex justify-around items-center px-2 py-3">
        {navigationItems.map((item) => {
          const isActive = currentView === item.id;
          const isDisabled = item.requiresClient && !selectedUserId;
          
          return (
            <button
              key={item.id}
              onClick={() => !isDisabled && onNavigate(item.id)}
              disabled={isDisabled}
              className={`
                ${item.id}-section flex flex-col items-center justify-center w-16 h-16 rounded-xl transition-all duration-200
                ${isActive 
                  ? `${item.bgColor} ${item.bgOpacity} ${item.color} shadow-md transform scale-105` 
                  : isDisabled
                  ? 'text-gray-400 opacity-50'
                  : 'text-text-medium hover:text-text-dark hover:bg-paper-cream'
                }
              `}
              aria-label={`Navigate to ${item.label}`}
              aria-pressed={isActive}
            >
              <span className="text-2xl mb-1">{item.icon}</span>
              <span className="text-xs font-medium hidden md:block">{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
} 